// The shared wavy lime hero background used by the wave-hero pages (home,
// poem, the program pages, schedule tour, staff pages via ProgramHero).
//
// The wave animates for everyone; visitors who prefer reduced motion get the
// static rendering — only the first 1200 units of the extended path visible
// untranslated. When animated, the path slides sideways inside the mask
// (SVG-native SMIL — no per-frame JS) so the crests travel gently like
// water; the wave repeats every 300 units, so translating by 600 loops
// seamlessly. (A layered two-wave interference variant lives in commit
// 56a36b40 if we ever want to revisit it.)
import { useMemo } from "react";

const WaveHeroBackground = ({
  maskId,
  className = "absolute inset-0 z-0 pointer-events-none",
}: {
  maskId: string;
  className?: string;
}) => {
  const animate = useMemo(
    () => typeof window !== "undefined" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    []
  );

  return (
    <div className={className}>
      <svg className="w-full h-full" viewBox="0 0 1200 200" preserveAspectRatio="none" aria-hidden="true">
        <defs>
          <mask id={maskId} x="0" y="0" width="1200" height="200" maskUnits="userSpaceOnUse">
            <rect width="1200" height="200" fill="white" />
            <g>
              {animate && (
                <animateTransform
                  attributeName="transform"
                  type="translate"
                  values="0 0; -600 0"
                  dur="9s"
                  repeatCount="indefinite"
                />
              )}
              <path
                d="M0,160 Q150,140 300,160 T600,160 T900,160 T1200,160 T1500,160 T1800,160 L1800,200 L0,200 Z"
                fill="black"
              />
            </g>
          </mask>
        </defs>
        <rect width="1200" height="200" fill="#C5E063" mask={`url(#${maskId})`} />
      </svg>
    </div>
  );
};

export default WaveHeroBackground;
